module.exports = __webpack_public_path__ + "img/kh.9f72f19b.png";